import ServerError from '@/common/utils/errors/ServerError';
import { AxiosResponse } from 'axios';

export const serverErrorMessage = 'Internal Server Error. Please contact your system administrator.';

export default class InternalServerError extends ServerError {
  constructor(response: CreateFetchResponse | AxiosResponse, body: ErrorBody) {
    super(response, body);

    if (process.env.NODE_ENV === 'production') {
      this.message = serverErrorMessage;
    } else {
      this.message = ((this.body as ErrorBody)?.error?.error?.message)
        || ((this.body as ErrorBody)?.message)
        || (response?.statusText)
        || 'Error';
    }
  }
}
